import Swiper from 'swiper';
import { Navigation, EffectFade } from 'swiper/modules';

export default function SectionScrollingCards(el) {
    const cardsContainer = el.querySelector('.section-scrolling-cards__content--desktop');
    const progressBar = el.querySelector('.section-scrolling-cards__progress-bar-inner');
    const nodesContainer = el.querySelector('.section-scrolling-cards__progress-bar-node-wrapper');
    const nodes = nodesContainer.querySelectorAll('.section-scrolling-cards__progress-bar-node');
    const container = el.querySelector('.scroll-container');

    const swiper = new Swiper(cardsContainer.querySelector('.swiper'), {
        modules: [
            Navigation,
            EffectFade,
        ],
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        centeredSlides: true,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        speed: 300,
        allowTouchMove: false,
    });

    function handleSlideChange(activeIndex) {
        nodes.forEach((node, index) => {
            // Clear all classes first
            node.classList.remove('active', 'semi-active');

            if (index === activeIndex) {
                // Current active node
                node.classList.add('active');
            } else if (index < activeIndex) {
                // Previous nodes become semi-active
                node.classList.add('semi-active');
            }
        });
    }

    window.addEventListener('scroll', () => {
        const containerRect = container.getBoundingClientRect();
        const totalScrollLength = containerRect.height - (window.innerHeight * 2);
        const scrolled = Math.min(Math.max(-containerRect.top, 0), totalScrollLength);
        const scrollProgress = totalScrollLength > 0 ? scrolled / totalScrollLength : 0;
        const targetIndex = Math.floor(scrollProgress * (nodes.length - 1));

        progressBar.style.height = `${scrollProgress * 100}%`;
        if (swiper.activeIndex !== targetIndex) {
            swiper.slideTo(targetIndex);
            handleSlideChange(targetIndex);
        }
    });

    nodes.forEach((node, i) => {
        node.onclick = () => {
            const scrollDist = window.innerHeight * i;

            window.scrollTo({
                top: container.offsetTop + scrollDist,
            });
            swiper.slideTo(i);
            handleSlideChange(i);
        };
    });

    handleSlideChange(0);

    const cardsContainerMobile = el.querySelector('.section-scrolling-cards__content--mobile');
    const cardsMobile = cardsContainerMobile.querySelector('.section-scrolling-cards__cards');
    const cardsNavPrev = cardsContainerMobile.querySelector('.section-scrolling-cards__card-nav-prev');
    const cardsNavNext = cardsContainerMobile.querySelector('.section-scrolling-cards__card-nav-next');

    new Swiper(cardsMobile, { // eslint-disable-line no-new
        modules: [
            Navigation,
            EffectFade,
        ],
        navigation: {
            prevEl: cardsNavPrev,
            nextEl: cardsNavNext,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
    });
}
